import emptyCadastroBase from './emptyCadastroBase'

export default {
  ...emptyCadastroBase,
  tipo: {
    codigo: 'PERMUTA'
  },
  json: {
    qualificacao: {
      pertenceAoProjeto: null,
      beneficiarioOriginal: null,
      pagoIntegral: null,
      gleba: {
        id: null,
        nome: null
      }
    },
    cadastrante: {
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      }
    },
    interessado: {
      id: null,
      espolio: null,
      documentos: [],
      sociosRepresentantesLegais: [],
      pessoa: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      },
      conjuge: {
        tipo: 'PF',
        email: null,
        cpfCnpj: null,
        nomeRazaoSocial: null,
        endereco: {
          bairro: null,
          cep: null,
          complemento: null,
          logradouro: null,
          municipio: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          numero: null,
          semNumero: false,
          uf: null
        },
        pessoaFisica: {
          id: null,
          nome: null,
          cpf: null,
          rg: null,
          nacionalidade: null,
          dataNascimento: null,
          orgaoExpedidor: {
            nome: null,
            estado: null
          },
          naturalidade: {
            id: null,
            nome: null,
            codigoEstado: null
          },
          ufNaturalidade: null,
          estadoCivil: null,
          possuiCertidaoObito: null,
          telefones: [],
          email: null
        },
        pessoaJuridica: {
          cnpj: null,
          razaoSocial: null,
          telefones: [],
          email: null
        },
        telefones: []
      }
    },
    imovel: {
      possuiCar: null,
      documentos: [],
      nomeImovelPropriedade: null,
      numeroReciboCar: null,
      numeroTitulo: null,
      tempoOcupacao: null,
      ocupantesAnteriores: null,
      possuiImovel: null,
      conflitos: null,
      causasImpossibilidadeOcupacao: null,
      numeroProcessoJudicial: null
    },
    georreferenciamento: {
      localizacoes: [],
      documentos: [],
      denominacao: '',
      possuiGeorreferenciamento: '',
      responsavel: {
        nome: '',
        codigoIncra: '',
        creaRnp: '',
        formacao: '',
        codigoCredenciamento: ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/screens/central/cadastros/para/empty/emptyPermuta.js